export default function blueconic() {
  return `
    <script src="https://c783.fastcompany.com/script.js"></script>
  `;
}
